// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TBhP","col":"styles_col__20mst"};